import type { FC } from 'react'
import { Box, Flex, Heading, Text } from '@grammarly/design-system'

import { NoTextAvailableIcon } from './NoTextAvailableIcon'

export interface NoTextAvailableProps {
  readonly agentName: string
}

export const NoTextAvailable: FC<NoTextAvailableProps> = ({ agentName }) => {
  return (
    <Box height="100%" padding={4} bgColor="background-base-default">
      <Flex direction="column" align="center" justify="center" height="100%" gap={4}>
        <NoTextAvailableIcon />
        <Flex direction="column" align="center" justify="center">
          <Heading as="h2" variant="heading-xsmall">
            No text available
          </Heading>
          <Text as="p" variant="text-small" color="base-subdued" align="center">
            Start editing text to get help from {agentName}.
          </Text>
        </Flex>
      </Flex>
    </Box>
  )
}
